import {
    RESET_VALIDATED_DATA,
    STORE_SURGERY_DETAILS,
    RESET_CONSIGNMENTRETURN_MYCASEREF_REFERENCE,
    SET_PATIENT_DETAILS,
    STORE_ITEM_TABLE_DATA,
    GET_USAGE_DETAILS_SUCCESS,
    GET_USAGE_DETAILS_FAILURE,
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
    VALIDATE_MAZOR_CODE_RESPONSE,
    VALIDATE_PRODUCT_DETAILS,
    VALIDATE_PRODUCT_DETAILS_SUCCESS,
    VALIDATE_PRODUCT_DETAILS_FAILURE,
    UPDATE_USAGE_ORDER_SUCCESS,
    UPDATE_USAGE_ORDER_FAILURE,
    DELETE_ATTACHMENT_REQUEST_SUCCESS,
    DELETE_ATTACHMENT_REQUEST_FAILURE,
    UPDATE_USAGE_ORDER,
    SET_ALL_ACCOUNT_OWNED_SELECTED,
    SET_PROCEDURE_DETAILS,
    SET_PRICE_OVERRIDE_DETAILS,
    RESET_ITEMTABLE_DATA,
    SHOW_HIDE_CONSIGNMENT_FOOTER,
    RESET_IS_FOR_REPLEN,
    SET_CHANGED_INDEX,
} from '../actions';

const initialState = {
    myCaseRefId: null,
    myCaseResourceType: null,
    fromOrdersList: false,
    usageDetails: {},
    itemTableData: [],
    isCreateUsage: false,
    pricedItems: null,
    priceOverRideDetails: {},
    validateMazorCodeRes: null,
    procedureInfoDetails: {},
    validProducts: null,
    isForReplen: false,
    isProductValidationDone: false,
    isProductsValidationInProgress: false,
    isUsageAttachmentUploaded: false,
    isUpdateUsageDone: false,
    isdeletionDone: false,
    patientDetails: {
        hrefId: '',
        patientFirstName: '',
        patientLastName: '',
        patientSalutation: '',
    },
    dropdownData: {},
    localSignatureDetails: {
        base64Image: '',
        dateOfSignature: '',
    },
    signatureItemState: [],
    isAllAccountOwnedSelected: false,
    setProcedureDetails: [],
    showConsignmentFooter: true,
    isPriceOverridePage: false,
    isForPriceOverride: false,
    changedIndex: -1,
};

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const consignmentReturnRootReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        // case RESET_REPORT_USAGE_STATES:
        //     return {
        //         ...initialState,
        //     };
        case RESET_CONSIGNMENTRETURN_MYCASEREF_REFERENCE:
            return {
                ...state,
                myCaseRefId: null,
                myCaseResourceType: null,
                fromOrdersList: false,
            };
        case STORE_SURGERY_DETAILS:
            return {
                ...state,
                surgeryData: action.payload,
                myCaseRefId:
                    action.payload && action.payload.myCaseRef
                        ? action.payload.myCaseRef
                        : state.myCaseRefId,
                myCaseResourceType:
                    action.payload && action.payload.resourceType
                        ? action.payload.resourceType
                        : state.myCaseResourceType,
                fromOrdersList:
                    action.payload && action.payload.fromOrdersList
                        ? action.payload.fromOrdersList
                        : state.fromOrdersList,
            };
        case GET_USAGE_DETAILS_SUCCESS:
        case GET_USAGE_DETAILS_FAILURE:
            return {
                ...state,
                usageDetails: action.payload,
            };
        case SET_PATIENT_DETAILS:
            return {
                ...state,
                patientDetails: action.payload.patientDetails,
                usageDetails: {
                    ...state.usageDetails,
                    hrefId: action.payload.patientDetails.hrefId,
                    patientFirstName:
                        action.payload.patientDetails.patientFirstName,
                    patientLastName:
                        action.payload.patientDetails.patientLastName,
                },
            };
        case STORE_ITEM_TABLE_DATA:
            return {
                ...state,
                itemTableData: action.payload,
            };
        case RESET_ITEMTABLE_DATA:
            return {
                ...state,
                itemTableData: [],
            };
        // case CREATE_USAGE_ORDER_SUCCESS:
        //     return {
        //         ...state,
        //         isCreateUsage: action.payload,
        //     };
        // case CREATE_USAGE_ORDER_FAILURE:
        //     return {
        //         ...state,
        //         isCreateUsage: false,
        //     };
        case 'CONSIGNMENT:STORE_ITEMS_DURING_PRICING':
            return {
                ...state,
                itemsToBePriced: action.payload,
            };
        case GET_PRICES_FOR_ITEMS_SUCCESS:
        case GET_PRICES_FOR_ITEMS_FAILURE:
            return {
                ...state,
                pricedItems: action.payload.items,
                isPricingDone: action.payload.isPricingDone,
            };
        case RESET_VALIDATED_DATA:
            return {
                ...state,
                validProducts: null,
                isProductValidationDone: false,
                pricedItems: null,
                itemsToBePriced: null,
            };
        // case GET_DROPDOWN_OPTIONS_SUCCESS:
        //     return {
        //         ...state,
        //         dropdownData: {
        //             [action.payload.dropdownName]:
        //                 action.payload.dropdownOptions,
        //         },
        //     };
        // case GET_DROPDOWN_OPTIONS_FAILURE:
        //     return {
        //         ...state,
        //         dropdownData: action.payload,
        //     };
        case VALIDATE_MAZOR_CODE_RESPONSE:
            return {
                ...state,
                validateMazorCodeRes: action.payload,
            };
        // case GET_PROCEDURE_INFO_SUCCESS:
        // case GET_PROCEDURE_INFO_FAILURE:
        //     return {
        //         ...state,
        //         procedureInfoDetails: action.payload,
        //     };
        case VALIDATE_PRODUCT_DETAILS:
            return {
                ...state,
                isProductsValidationInProgress: true,
            };
        case VALIDATE_PRODUCT_DETAILS_SUCCESS:
            return {
                ...state,
                validProducts: action.payload.validItems,
                isProductValidationDone: action.payload.productsValidated,
                isForReplen: action.payload.isForReplen,
                isForPriceOverride: action.payload.isForPriceOverride
            };
        case VALIDATE_PRODUCT_DETAILS_FAILURE:
            return {
                ...state,
                validProducts: action.payload.validItems,
                isProductValidationDone: action.payload.productsValidated,
                isForReplen: action.payload.isForReplen,
                isForPriceOverride: action.payload.isForPriceOverride
            };
        case RESET_IS_FOR_REPLEN:
            return {
               ...state,
               isForReplen:action.payload
            }; 
            
        // case USAGE_ATTACHMENT_UPLOAD_SUCCESS:
        //     return {
        //         ...state,
        //         isUsageAttachmentUploaded: action.payload,
        //     };
        // case USAGE_ATTACHMENT_UPLOAD_FAILURE:
        //     return {
        //         ...state,
        //         isUsageAttachmentUploaded: false,
        //     };
        case UPDATE_USAGE_ORDER_SUCCESS:
            return {
                ...state,
                isUpdateUsageDone: action.payload,
            };
        case UPDATE_USAGE_ORDER:
            return {
                ...state,
                isUpdateUsageDone: action.payload,
            };
        // case CREATE_USAGE_ORDER:
        //     return {
        //         ...state,
        //         isUpdateUsageDone: action.payload,
        //     };
        case UPDATE_USAGE_ORDER_FAILURE:
            return {
                ...state,
                isUpdateUsageDone: false,
            };
        case DELETE_ATTACHMENT_REQUEST_SUCCESS:
            return {
                ...state,
                isdeletionDone: action.payload,
            };
        case DELETE_ATTACHMENT_REQUEST_FAILURE:
            return {
                ...state,
                isdeletionDone: false,
            };
        case 'SET_LOCAL_SIGNATURE': {
            return {
                ...state,
                localSignatureDetails: action.payload,
            };
        }
        case 'SET_ITEM_STATE_SIGNATURE': {
            return {
                ...state,
                signatureItemState: action.payload,
            };
        }
        case SET_ALL_ACCOUNT_OWNED_SELECTED: {
            return {
                ...state,
                isAllAccountOwnedSelected: action.payload,
            };
        }
        case SET_PRICE_OVERRIDE_DETAILS:
            return {
                ...state,
                priceOverRideDetails: action.payload,
                itemTableData: action.payload,
            };
        // case CHECK_IS_PRICEOVERRIDE_PAGE:
        //     return {
        //         ...state,
        //         isPriceOverridePage: action.payload,
        //     };
        case SET_PROCEDURE_DETAILS: {
            return {
                ...state,
                setProcedureDetails: action.payload,
            };
        }
        case SHOW_HIDE_CONSIGNMENT_FOOTER: {
            return {
                ...state,
                showConsignmentFooter: action.payload,
            };
        }
        case SET_CHANGED_INDEX: {
            return {
                ...state,
                changedIndex: action.payload,
            };
        }
        default:
            return {
                ...state,
            };
    }
};

export default persistReducer(
    {
        key: 'consignmentReturnRootReducerKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    consignmentReturnRootReducer
);

